import React from 'react';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import Home from './pages/Home';
import '@questlabs/react-sdk/dist/style.css'; 

function App() {
  return (
    <div className="font-sans bg-slate-950 min-h-screen text-slate-200">
      <Header />
      <Home />
      <Footer />
    </div>
  );
}

export default App;